import { ISSUE_HEADER_SHADOW_HEIGHT } from '@atlassian/jira-issue-view-sticky-header-container/src/index.tsx';

export const LOG_LOCATION = 'issue.views.issue-base.context.side-panel';
export const EXTRA_GLANCE_PANEL_OFFSET = ISSUE_HEADER_SHADOW_HEIGHT * 2; // second shadow is applied to panel header on focus
